var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.6178 22.0007C19.6178 18.3987 15.6018 15.4707 11.9998 15.4707C8.39784 15.4707 4.38184 18.3987 4.38184 22.0007M11.9998 12.2067C13.1543 12.2067 14.2615 11.7481 15.0779 10.9318C15.8942 10.1154 16.3528 9.00822 16.3528 7.85373C16.3528 6.69925 15.8942 5.59204 15.0779 4.7757C14.2615 3.95935 13.1543 3.50073 11.9998 3.50073C10.8453 3.50073 9.73815 3.95935 8.9218 4.7757C8.10545 5.59204 7.64684 6.69925 7.64684 7.85373C7.64684 9.00822 8.10545 10.1154 8.9218 10.9318C9.73815 11.7481 10.8453 12.2067 11.9998 12.2067Z","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

User.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = User;

User.default = User;
